var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xiQ-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card_InstantList",
    transform: "translate(-78.000000, -239.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_company_3654353",
    transform: "translate(78.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98,15.855 C7.86975,15.848875 7.760375,15.827 7.658,15.785875 C7.434875,15.69575 7.258125,15.516375 7.170625,15.292375 C7.13125,15.192625 7.111125,15.08675 7.105,14.98 L7.105,12.355 L5.355,12.355 L5.355,14.98 C5.34975,15.08325 5.3305,15.185625 5.29375,15.28275 C5.215,15.490125 5.061,15.661625 4.8615,15.759625 C4.76875,15.806 4.669,15.834875 4.566625,15.850625 L4.48,15.855 L0.98,15.855 C0.748125,15.855 0.525,15.763125 0.361375,15.598625 C0.196875,15.435 0.105,15.211875 0.105,14.98 C0.105,12.222875 0.105,3.737125 0.105,0.98 C0.105,0.497 0.497,0.105 0.98,0.105 C3.234875,0.105 9.225125,0.105 11.48,0.105 C11.963,0.105 12.355,0.497 12.355,0.98 L12.355,5.355 L14.98,5.355 C15.211875,5.355 15.435,5.446875 15.598625,5.611375 C15.763125,5.775 15.855,5.998125 15.855,6.23 C15.855,8.2075 15.855,13.0025 15.855,14.98 C15.855,15.211875 15.763125,15.435 15.598625,15.598625 C15.435,15.763125 15.211875,15.855 14.98,15.855 L7.98,15.855 Z M10.605,14.105 L10.605,1.855 L1.855,1.855 L1.855,14.105 L3.605,14.105 C3.605,14.105 3.605,12.516875 3.605,11.48 C3.605,11.248125 3.696875,11.025 3.861375,10.861375 C4.025,10.696875 4.248125,10.605 4.48,10.605 C5.45125,10.605 7.00875,10.605 7.98,10.605 C8.211875,10.605 8.435,10.696875 8.598625,10.861375 C8.763125,11.025 8.855,11.248125 8.855,11.48 C8.855,12.516875 8.855,14.105 8.855,14.105 L10.605,14.105 Z M14.105,7.105 L12.355,7.105 L12.355,14.105 L14.105,14.105 L14.105,7.105 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.48,
    cy: 4.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.48,
    cy: 7.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.98,
    cy: 4.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.98,
    cy: 7.98,
    r: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.f8359376.svg";
export { ForwardRef as ReactComponent };